module.exports = __webpack_public_path__ + "static/media/Main_Street.973bfec2.svg";